<script>
import ContentsWithLinks from "@/components/article/politiken/ContentsWithLinks.vue";
import Tooltip from "@/components/article/Tooltip.vue";

export default {
  name: "ArticleContentElaborations",
  components: {
    ContentsWithLinks,
    Tooltip
  },
  props: {
    word: {
      type: Object,
      required: true
    }
  },
  computed: {
    showTooltip() {
      // This tooltip is only for verbs.
      return this.word.wordClass === "at" && this.word.flexion.indexOf("÷") > -1;
    },
    inflectionsParsed() {
      const inflections = this.word.flexion.split(", ");
      const noImperativeSymbolIndex = inflections.indexOf("÷");

      if (noImperativeSymbolIndex > -1) {
        inflections.splice(noImperativeSymbolIndex, 1);
      }

      return inflections.join(", ");
    }
  }
};
</script>

<template>
  <div>
    <div v-if="word.flexion" class="article-content__politiken-grid-indexed">
      <span class="article-content__text article-content__politiken-grid-indexed-label">
        {{ $t("article.polChildrensDada.inflect") }}
      </span>
      <span class="article-content__politiken-grid-indexed-content">
        <span
          class="article-content__text article-content__text--primary mr-2"
          v-html="inflectionsParsed"
        />
        <Tooltip v-if="showTooltip" :text="$t('article.polChildrensDada.noImperative')" />
      </span>
    </div>
    <div v-if="word.hyphenation" class="article-content__politiken-grid-indexed">
      <span class="article-content__text article-content__politiken-grid-indexed-label">
        {{ $t("article.polChildrensDada.hyphenate") }}
      </span>
      <span
        class="article-content__text article-content__text--primary article-content__politiken-grid-content"
        v-html="word.hyphenation"
      />
    </div>
    <div v-if="word.abbreviation" class="article-content__politiken-grid-indexed">
      <span class="article-content__text article-content__politiken-grid-indexed-label">
        {{ $t("article.polChildrensDada.abbreviate") }}
      </span>
      <span class="article-content__politiken-grid-indexed-content">
        <b
          class="article-content__text article-content__text--primary"
          v-html="word.abbreviation"
        />
      </span>
    </div>
    <div v-if="word.grammar">
      <ContentsWithLinks
        v-for="(grammar, index) in word.grammar"
        :key="index"
        :content="grammar"
        text-class="article-content__text"
        link-class="article-content__text article-content__text--dark"
      />
    </div>
    <div v-if="word.reference">
      <span class="article-content__text article-content__text--italic" v-html="word.reference" />
    </div>
  </div>
</template>
